import { Box, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CusDataGrid from '../../../components/material-ui/CusDataGrid';

export default function PivotTable({ deposits }) {
  const { t } = useTranslation();

  const infoTable = useMemo(() => {
    const info = {};
    deposits.forEach((el) => {
      const curCode = el[5];
      if (!info[curCode]) info[curCode] = { code: curCode };
      if (!info[curCode].applications) info[curCode].applications = 0;
      if (!info[curCode].replenishment) info[curCode].replenishment = 0;
      if (!info[curCode].received) info[curCode].received = 0;
      if (!info[curCode].commission) info[curCode].commission = 0;

      info[curCode].applications++;
      info[curCode].replenishment += el[4];
      info[curCode].commission += el[7];
    });

    return info;
  }, [deposits]);

  const rows = Object.values(infoTable).map((el) => ({
    id: el.code,
    currency: el.code,
    applications: el.applications,
    replenishment: el.replenishment.toFixed(2),
    received: (el.replenishment - el.commission).toFixed(2),
    commission: el.commission.toFixed(2)
  }));

  const column = [
    { field: 'currency', headerName: t('Currency'), headerClassName: 'bold-header', minWidth: 60 },
    {
      field: 'applications',
      headerName: t('Orders'),
      headerClassName: 'bold-header',
      align: 'right',
      minWidth: 60
    },
    {
      field: 'replenishment',
      headerName: t('Replenishments'),
      headerClassName: 'bold-header',
      align: 'right',
      width: 125,
      minWidth: 120
    },
    {
      field: 'commission',
      headerName: t('Commission'),
      headerClassName: 'bold-header',
      align: 'right',
      minWidth: 90
    },
    {
      field: 'received',
      headerName: t('Received'),
      headerClassName: 'bold-header',
      minWidth: 90,
      align: 'right'
    }
  ];

  return (
    <Stack gap={1} width={'100%'}>
      <CusDataGrid
        labelFontWeight={600}
        label={'Total replenishment'}
        rows={rows}
        columns={column}
        checkboxSelection={false}
      />
    </Stack>
  );
}
